// PANADERIA ALMEDA THEME JS
document.addEventListener('DOMContentLoaded', function() {

  // Quick menu
  var menuBtn = document.getElementById('QuickMenuBtn');
  var menuDrop = document.getElementById('QuickMenuDrop');
  if (menuBtn && menuDrop) {
    menuBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      menuDrop.classList.toggle('open');
    });
    document.addEventListener('click', function() {
      menuDrop.classList.remove('open');
    });
  }

  // Slideshow
  var slideshow = document.getElementById('Slideshow');
  if (slideshow) {
    var slides = slideshow.querySelectorAll('.slideshow__slide');
    var dots = slideshow.querySelectorAll('.slideshow__dot');
    var current = 0;
    function showSlide(i) {
      slides.forEach(function(s,idx){ s.classList.toggle('active', idx===i); });
      dots.forEach(function(d,idx){ d.classList.toggle('active', idx===i); });
      current = i;
    }
    dots.forEach(function(d) {
      d.addEventListener('click', function() { showSlide(parseInt(d.dataset.index)); });
    });
    if (slides.length > 1) setInterval(function(){ showSlide((current+1) % slides.length); }, 4000);
  }

  // Cart drawer
  var cartTrigger = document.getElementById('CartTrigger');
  var drawerOverlay = document.getElementById('DrawerOverlay');
  var cartDrawer = document.getElementById('CartDrawer');
  var drawerClose = document.getElementById('DrawerClose');
  var drawerViewCart = document.getElementById('DrawerViewCart');
  function openDrawer() { if(drawerOverlay) drawerOverlay.classList.add('open'); if(cartDrawer) cartDrawer.classList.add('open'); }
  function closeDrawer() { if(drawerOverlay) drawerOverlay.classList.remove('open'); if(cartDrawer) cartDrawer.classList.remove('open'); }
  if (cartTrigger) cartTrigger.addEventListener('click', function(e){ e.preventDefault(); openDrawer(); });
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawerViewCart) drawerViewCart.addEventListener('click', function() { window.location.href = '/cart'; });

});
